var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c("div", { staticClass: "gold-page" }, [
        _c("div", { staticClass: "common-title" }, [_vm._v("祺信详情")]),
        _vm._v(" "),
        _c("div", { staticClass: "page-main no-shadow" }, [
          _c("div", { staticClass: "spaceBetween" }, [
            _c("div", [
              _c("div", { staticClass: "gold-line" }, [
                _vm._v(
                  "开立日：" +
                    _vm._s(
                      _vm._f("dateFormat")(_vm.goldData.estbDay, "YYYY-mm-dd")
                    )
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "gold-line" }, [
                _vm._v(
                  "到期日：" +
                    _vm._s(
                      _vm._f("dateFormat")(_vm.goldData.exDay, "YYYY-mm-dd")
                    )
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "font-weight": "bold",
                  "font-size": "18px",
                  position: "relative",
                  left: "20px"
                }
              },
              [_vm._v("祺信")]
            ),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "gold-line" }, [
                _vm._v(
                  "状态：\n                      " +
                    _vm._s(
                      _vm._f("GbGldStCdTrans")(
                        _vm.goldData.isPledged == 1
                          ? _vm.goldData.pledgeStatus | _vm.pledgeStatus
                          : _vm.goldData.gldStCd
                      )
                    ) +
                    "\n                  "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "gold-line" }, [
                _vm._v("编号：" + _vm._s(_vm.goldData.gldId))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("table", { staticClass: "gold-detail-table" }, [
            _vm.goldData.isPledged != 1
              ? _c("tr", [
                  _c("td", [_vm._v("流转方")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.goldData.pyptNm))]),
                  _vm._v(" "),
                  _c("td", [_vm._v("统一社会信用代码")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.goldData.pyptOrgCode))])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.goldData.isPledged != 1
              ? _c("tr", [
                  _c("td", [_vm._v("接收方")]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm.goldData.rcPtyNm ||
                          _vm.goldData.tenantNm ||
                          _vm.goldData.tenantName
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v("统一社会信用代码")]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm.goldData.rcPtyOrgCode || _vm.goldData.tenantOrgCode
                      )
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("开立方")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.goldData.estbNm))]),
              _vm._v(" "),
              _c("td", [_vm._v("统一社会信用代码")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.goldData.estbOrgCode))])
            ]),
            _vm._v(" "),
            _vm.goldData.grtStCd == 2
              ? _c("tr", [
                  _c("td", [_vm._v("保证人")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.goldData.guarantorName))]),
                  _vm._v(" "),
                  _c("td", [_vm._v("统一社会信用代码")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.goldData.guarantorOrgCode))])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.goldData.isPledged == 1
              ? _c("tr", [
                  _c("td", [_vm._v("出质人")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.goldData.pledgorNm))]),
                  _vm._v(" "),
                  _c("td", [_vm._v("统一社会信用代码")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.goldData.pledgorOrgCode))])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.goldData.isPledged == 1
              ? _c("tr", [
                  _c("td", [_vm._v("质权人")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.goldData.pledgeeName))]),
                  _vm._v(" "),
                  _c("td", [_vm._v("统一社会信用代码")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.goldData.pledgeeOrgCode))])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                { staticStyle: { height: "50px" }, attrs: { colspan: "4" } },
                [
                  _c("span", [_vm._v("祺信金额")]),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "margin-left": "60px" } }, [
                    _vm._v("(大写)" + _vm._s(_vm.goldData.bigGldAmt))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "margin-left": "160px" } }, [
                    _vm._v(
                      "(小写)¥" + _vm._s(_vm._f("splitK")(_vm.goldData.gldAmt))
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { attrs: { colspan: "4" } }, [
                _c("span", [
                  _vm._v(
                    "\n                      开立方声明：我司已对本祺信出具《付款承诺函（" +
                      _vm._s(_vm.goldData.firstGldId) +
                      "\n                          ）》，到期无条件依据持票方明细付款。    承诺日期：" +
                      _vm._s(
                        _vm._f("dateFormat")(
                          _vm.goldData.signTime,
                          "YYYY-mm-dd"
                        )
                      ) +
                      "\n                      "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            +_vm.goldData.isPledged !== 1
              ? _c("tr", [
                  _c(
                    "td",
                    {
                      staticClass: "detail-table__remarks",
                      attrs: { colspan: "4" }
                    },
                    [
                      +_vm.goldData.canBeModified === 0
                        ? _c("span", [
                            _vm._v("备注：本祺信可以全部或部分流转支付"),
                            _vm.goldData.firstGldId !== _vm.goldData.gldId
                              ? _c("span", [_vm._v("，也可以随时申请融资")])
                              : _vm._e(),
                            _vm._v("。")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      +_vm.goldData.canBeModified === 1 ||
                      +_vm.goldData.canBeModified === 3
                        ? _c("span", [
                            _vm._v("备注：本祺信可以全部或部分流转支付"),
                            _vm.goldData.firstGldId !== _vm.goldData.gldId
                              ? _c("span", [_vm._v("，也可以随时申请融资")])
                              : _vm._e(),
                            _vm._v("。"),
                            _c("b", [
                              _vm._v(
                                "开立方可对本祺信的到期日期进行变更，变更后的祺信到期日期将早于" +
                                  _vm._s(
                                    _vm._f("dateFormat")(
                                      _vm.goldData.exDay,
                                      "YYYY-mm-dd"
                                    )
                                  ) +
                                  "。"
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      +_vm.goldData.canBeModified === 2
                        ? _c("span", [
                            _vm._v("备注：本祺信可以全部或部分流转支付"),
                            _vm.goldData.firstGldId !== _vm.goldData.gldId
                              ? _c("span", [_vm._v("，也可以随时申请融资")])
                              : _vm._e(),
                            _vm._v("。"),
                            _c("b", [
                              _vm._v(
                                "开立方已于" +
                                  _vm._s(
                                    _vm._f("dateFormat")(
                                      _vm.goldData.modifiedDay,
                                      "YYYY-mm-dd"
                                    )
                                  ) +
                                  "，将到期日期由" +
                                  _vm._s(
                                    _vm._f("dateFormat")(
                                      _vm.goldData.beforeModified,
                                      "YYYY-mm-dd"
                                    )
                                  ) +
                                  "变更为" +
                                  _vm._s(
                                    _vm._f("dateFormat")(
                                      _vm.goldData.afterModified,
                                      "YYYY-mm-dd"
                                    )
                                  ) +
                                  "。"
                              )
                            ])
                          ])
                        : _vm._e()
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            +_vm.goldData.isPledged === 1 ? _c("tr", [_vm._m(0)]) : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "spaceBetween",
              staticStyle: { "margin-top": "10px" }
            },
            [
              _vm._m(1),
              _vm._v(" "),
              _c("div", [
                _c("div", { staticClass: "gold-line" }),
                _vm._v(" "),
                _c("div", { staticClass: "gold-line" }, [
                  _vm._v(
                    "贷：应收账款-祺信(" + _vm._s(_vm.goldData.gldId) + "） "
                  )
                ])
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("goldDetailOriginInfo", {
        attrs: { goldData: _vm.goldData, goldIdParam: _vm.goldData.gldId },
        on: {
          "update:goldData": function($event) {
            _vm.goldData = $event
          },
          "update:gold-data": function($event) {
            _vm.goldData = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "spaceCenter page-bottom-btns" },
        [
          _c(
            "a-button",
            {
              staticClass: "btn-blue-line",
              staticStyle: { margin: "30px 0" },
              on: {
                click: function($event) {
                  return _vm.goBack()
                }
              }
            },
            [_vm._v("返回")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      { staticClass: "detail-table__remarks", attrs: { colspan: "4" } },
      [
        _c("span", [
          _vm._v("备注：本祺信已质押,清分款项需先用于偿还出质人的债务.")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "gold-line" }, [_vm._v("流转方财务记账建议：")]),
      _vm._v(" "),
      _c("div", { staticClass: "gold-line" }, [_vm._v("借：银行存款")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "gold-line", staticStyle: { "margin-left": "28px" } },
        [_vm._v("财务费用")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3423c3e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3423c3e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/financing-page/gold-detail.vue
// module id = GAKv
// module chunks = 1